import {
  Email,
  Facebook,
  Instagram,
  LinkedIn,
  LocationOn,
  Phone,
  Twitter,
} from "@mui/icons-material";
import {
  Button,
  Checkbox,
  Container,
  Grid,
  InputLabel,
  TextField,
} from "@mui/material";
import { HeaderComp } from "components";
import { useAppContext } from "contexts";
import { useFormik } from "formik";
import { db, useIsMounted } from "hooks";
import React, { useEffect } from "react";
import { useState } from "react";
import Swal from "sweetalert2";
import * as Yup from "yup";

const Contactus = () => {
  const isMounted = useIsMounted();

  const { user } = useAppContext();

  const [initialValues, setInitialValues] = useState({
    name: "",
    email: "",
    message: "",
    phone: "",
    queryType: "",
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: Yup.string().required("Required"),
      email: Yup.string().required("Required").email("Invalid email address"),
      message: Yup.string().required("Required"),
      phone: Yup.string()
        .required("Required")
        .matches(
          /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,10}$/g,
          "Invalid phone number"
        ),
      queryType: Yup.string().required("Required"),
    }),
    onSubmit: async (values, submitProps) => {
      try {
        await db.pushData("contactus", {
          ...values,
          read: false,
          createdAt: Date.now(),
        });

        Swal.fire({
          title: "Success",
          text: "Your message has been sent successfully ! We will get back to you soon.",
          icon: "success",
          confirmButtonText: "OK",
        });
        submitProps.setSubmitting(false);
        submitProps.resetForm(initialValues);
      } catch (error) {
        console.log(error);
        Swal.fire({
          title: "Error",
          text: "Something went wrong",
          icon: "error",
        });
      }
    },
  });

  useEffect(() => {
    if (isMounted.current) {
      if (!user?.uid) return;
      setInitialValues((prev) => {
        return {
          ...prev,
          name: user?.displayName,
          email: user?.email,
          phone: user?.phoneNumber,
        };
      });
    }
  }, [isMounted, user]);

  // console.log(formik.values);

  return (
    <main className="contact-us-main">
      <div className="contact-us-header">
        <HeaderComp title="Contact Us" />
      </div>
      <section className="contact-us-main-section">
        <Container>
          <Grid container className="contact-us-container flex-row ">
            <Grid item xs={12} md={5} className="contact-us-container-left  ">
              <h3 className="contact-left-title">Contact Information</h3>
              <p className="contact-us-left-desc">
                Fill up the form below and our team will get back to you in 24
                hours.
              </p>
              {/* <div className="contact-information  flex-column gap-2"> */}
              <span className="contact-info-phone   contact-information   flex-row align-items-center gap-2">
                <span className="flex-row align-items-center">
                  <Phone />
                </span>
                <span className="flex-row align-items-center">
                  +91-9888888888
                </span>
              </span>
              <span className="contact-info-email  contact-information    flex-row align-items-center gap-2">
                <span className="flex-row align-items-center">
                  <Email />
                </span>
                <span className="flex-row align-items-center">
                  info@searchingyard.com
                </span>
              </span>
              <span className="contact-info-location   contact-information   flex-row align-items-center gap-2">
                <span className="flex-row align-items-center">
                  <LocationOn />
                </span>
                <span className="flex-row align-items-center">
                  Khandagiri,Bhubaneswar,Odisha,India
                </span>
              </span>
              {/* </div> */}
              {/* <div className="contact-information  flex-column gap-2">
                <span className="contact-info-phone flex-row align-items-center gap-2">
                  <span className="flex-row align-items-center">
                    <Phone />
                  </span>
                  <span className="flex-row align-items-center">
                    +91-9888888888
                  </span>
                </span>
                <span className="contact-info-email flex-row align-items-center gap-2">
                  <span className="flex-row align-items-center">
                    <Email />
                  </span>
                  <span className="flex-row align-items-center">
                    info@searchingyard.com
                  </span>
                </span>
                <span className="contact-info-location flex-row align-items-center gap-2">
                  <span className="flex-row align-items-center">
                    <LocationOn />
                  </span>
                  <span className="flex-row align-items-center">
                    Khandagiri,Bhubaneswar,Odisha,India
                  </span>
                </span>
              </div> */}
              <div className="contact-social-info flex-row align-items-center gap-2 flex-wrap ">
                <span className="contact-icons">
                  <Facebook />
                </span>
                <span className="contact-icons">
                  <Twitter />
                </span>
                <span className="contact-icons">
                  <Instagram />
                </span>
                <span className="contact-icons">
                  <LinkedIn />
                </span>
              </div>
            </Grid>
            <Grid item xs={12} md={7} className="contact-us-container-right">
              <form onSubmit={formik.handleSubmit}>
                <div className="contact-form">
                  <Grid
                    container
                    className="flex-row align-items-center  justify-content-between gap-2 contact-details "
                    // spacing={2}
                  >
                    <Grid item xs={12} sm={12}>
                      <TextField
                        id="first-name"
                        label="Name"
                        variant="standard"
                        className="w-100"
                        name="name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.name && formik.errors.name}
                        helperText={
                          formik.touched.name && formik.errors.name
                            ? formik.errors.name
                            : null
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={5}>
                      <TextField
                        id="Mail"
                        label="E-mail"
                        variant="standard"
                        className="w-100"
                        name="email"
                        type="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.email && formik.errors.email}
                        helperText={
                          formik.touched.email && formik.errors.email
                            ? formik.errors.email
                            : null
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={5}>
                      <TextField
                        id="Phone"
                        label="Phone"
                        variant="standard"
                        className="w-100"
                        type="number"
                        name="phone"
                        value={formik.values.phone}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.phone && formik.errors.phone}
                        helperText={
                          formik.touched.phone && formik.errors.phone
                            ? formik.errors.phone
                            : null
                        }
                      />
                    </Grid>
                  </Grid>
                </div>
                <div className="type-of-contact">
                  <h3 className="types-of-contact-h3">
                    What is your enquiry about?
                  </h3>

                  <div className="type-of-message-checkbox flex-row align-items-center flex-wrap">
                    <span className="contact-us-checkbox">
                      <Checkbox
                        checked={formik.values?.queryType === "delivery"}
                        onClick={() => {
                          formik.setFieldValue("queryType", "delivery");
                        }}
                      />
                      <p>Delivery</p>
                    </span>
                    <span className="contact-us-checkbox">
                      <Checkbox
                        checked={formik.values?.queryType === "payment"}
                        onClick={() => {
                          formik.setFieldValue("queryType", "payment");
                        }}
                      />
                      <p>Payment</p>
                    </span>
                    <span className="contact-us-checkbox">
                      <Checkbox
                        checked={formik.values?.queryType === "other"}
                        onClick={() => {
                          formik.setFieldValue("queryType", "other");
                        }}
                      />
                      <p>Others</p>
                    </span>
                  </div>
                  {formik?.touched?.queryType && (
                    <div className="error-message">
                      {formik.errors.queryType}
                    </div>
                  )}
                </div>
                <div className="contact-us-message-box">
                  <InputLabel>
                    <p className="contact-us-message-title"> Enter Message</p>
                  </InputLabel>
                  <TextField
                    multiline
                    rows={5}
                    className="w-100"
                    variant="standard"
                    id="message"
                    name="message"
                    value={formik.values.message}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.message && formik.errors.message}
                    helperText={
                      formik.touched.message && formik.errors.message
                        ? formik.errors.message
                        : null
                    }
                  />
                </div>

                <div className="contact-message-sender-btn">
                  <Button type="submit">Send Message</Button>
                </div>
              </form>
            </Grid>
          </Grid>
        </Container>
      </section>
    </main>
  );
};

export default Contactus;
